module.exports = __webpack_public_path__ + "static/media/landing_image_2.45b58166.jpg";